import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from "../../../../Context/Context";
import { Menu } from "../Menu";
import { MenuLateral } from "../MenuLateral";

export const HaberNeto = ({ match, history }) => {
    const [conceptos, setConceptos] = useState([]);
    const [state, setState] = useContext(AppContext);
    const [leyenda, setLeyenda] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        const id = atob(sessionStorage.getItem("dtpln"));

        let plan = null;
        if (state.data !== null) {
            const planes = state.data.Usuario.Datos.Planes.Plan;
            plan = planes.filter(plan => plan.Id === id)[0];
        }

        const fetchHaberAdherente = async () => {
            try {
                const documento = atob(sessionStorage.getItem("dtdc"));
                const endpoint = await (await fetch('/api/show_endpoints/wsconsultarhaberadherente')).json();
                const brand = await (await fetch('/api/get_brand')).json();
                const timestamp = new Date().getTime();

                const response = await fetch(
                    `${endpoint.url_base}${endpoint.url_variable}?Marca=${brand.nombre}&Solicitud=${plan.Solicitud}&Grupo=${plan.Grupo}&Orden=${plan.Orden}&Cuit=${documento}&timestamp=${timestamp}`,
                    {
                        cache: "no-cache",
                    }
                );

                const data = await response.json();

                if (!data || data.Error.Codigo !== "00") {
                    setError(data?.Error?.Mensaje || "Error fetching data");
                    return;
                }

                setConceptos(data.Concepto);
                setLeyenda(data.Leyenda);
            } catch (err) {
                console.error("Error: ", err);
                setError("Error fetching data");
            }
        };

        fetchHaberAdherente();

    }, [match.params.CUIT, history]);

    return (
        <div>
            <Menu />
            <div className="wrap">
            <MenuLateral key={state.selectedPlan?.Id || "default-key"} />
                <div className="next-to-sidebar">
                    <div className="haberNeto">
                        <div className="datos_mainDiv mt-doub">
                            <div className="datos_mainDiv--user">
                                <p>Haber Neto</p>
                                <div className="separator--hor mt-half mb-half"></div>
                            </div>
                        </div>
                        <div className="instructivos_mainDiv">
                            {error && <p className="text-red-600">{error}</p>}
                            <table className="table-auto">
                                <thead>
                                    <tr>
                                        <th className="py-1 text-left">CONCEPTO</th>
                                        <th className="px-4 py-1 text-right">MONTO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {conceptos.map((item, index) => (
                                        <tr key={index}>
                                            <td className="py-1">{item.Descripcion}</td>
                                            <td className="px-4 py-1 text-right">{item.Importe}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <p className="mt-3">{leyenda}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
